<template>
    <b-container fluid>
        <b-card v-for="order in ordersArray"  :key="'buyercard'+order.mainorderid" style="margin-bottom:10px; background-color:#f2f2f2; color:#000"
        :title="order.brewer"
        >
        {{order.docId}}
            <b-row :key="'buyeraddress'+order.mainorderid" style="">
                <b-col>
                    Address: <span style="font-weight:bold; color:#2e5189">{{order.billingaddress}}</span>
                </b-col>
            </b-row>
            <b-row :key="'orderdate'+order.mainorderid">
                <b-col>
                    Order Date: <span style="font-weight:bold; color:#2e5189">{{order.date}}</span>
                </b-col>
            </b-row>
            <b-row :key="'shippingterms'+order.mainorderid">
                <b-col>
                    Shipping Terms: <span style="font-weight:bold; color:#2e5189">{{order.selectedDeliveryOption}}</span>
                </b-col>
            </b-row>
            <!-- Actions for this consumer -->
            <b-row :key="'orders'+order.mainorderid">
                <b-col>

                    <b-button-group style="margin-top:10px; margin-bottom:10px">
                        <!-- Send message button -->
                        <b-button v-b-modal="'sendmsgmodal' + order.mainorderid" v-b-tooltip.hover :title="'Message '+order.pub" 
                            class='btn btn-success action-buttons'><i><font-awesome-icon icon="comment" /></i>
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
            <!-- Send message modal -->
            <b-modal :id="'sendmsgmodal' + order.mainorderid" title="Send a Message"  hide-footer :key="'sendmsgmodalkey' + order.mainorderid">
                <div class='col-12'>
                    <sendmessage  :receiverId="order.brewerid" :receiverName="order.brewer" :arrayDefaultMessages="arrayDefaultMessages"/>
                </div>
            </b-modal>

            <b-row :key="'messages'+order.mainorderid">
                <b-col>
                    <!-- Table of items in order -->
                    <table class="table table-bordered">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col"><small>Beverage</small></th>
                                <th scope="col"><small>Quantity</small></th>
                                <th scope="col"><small>Container</small></th>
                                <th scope="col"><small>Cost</small></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in order.cartItems" :key="item.id+item.suborderid">
                                <td>{{item.beerName}}</td>
                                <td>{{item.orderQuantity}}</td>
                                <td>{{item.size}}</td>
                                <td>$ {{item.itemsCost}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-col>
            </b-row>
            <b-row :key="'itemscost'+order.mainorderid" style="text-align:right">
                <b-col>
                    <small>Items Cost: $ {{order.totalItemsCost}}</small>
                </b-col>
            </b-row>
            <b-row :key="'itemstax'+order.mainorderid" style="text-align:right">
                <b-col>
                    <small>Taxes: $ {{order.tax}}</small>
                </b-col>
            </b-row>
            <b-row :key="'itemsshipping'+order.mainorderid" v-if="order.shippingCost>0" style="text-align:right">
                <b-col>
                    <small>Shipping Cost: $ {{order.shippingCost}}</small>
                </b-col>
            </b-row>
            <b-row :key="'itemsdelivery'+order.mainorderid" v-if="order.deliveryCost>0" style="text-align:right">
                <b-col>
                    <small>Delivery Cost: $ {{order.deliveryCost}}</small>
                </b-col>
            </b-row>
            <b-row v-if="order.kegDeposit>0" :key="'kegdeposit'+order.mainorderid" style="text-align:right">
                <b-col>
                    <small>Keg Deposit: $ {{order.kegDeposit}}</small>
                </b-col>
            </b-row>
            
            <b-row :key="'itemstotalcost'+order.mainorderid" style="text-align:right; color:green">
                <b-col>
                    Total Cost: $ {{parseFloat(order.totalCost).toFixed(2)}}
                </b-col>
            </b-row>
            <!-- Shipping Info -->
            <b-row :key="'shippingcarrier1'+order.mainorderid" v-if="order.shippingCarrier">
                <b-col>
                    Shipping Carrier: {{order.shippingCarrier}}
                </b-col>
                <b-col :key="'trackingnumber1'+order.mainorderid" v-if="order.trackingNumber">
                    Tracking Number: {{order.trackingNumber}}
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')
    import Sendmessage from '../Sendmessage'

    export default {
        props: ['ordersArray'],
        components: {
            Sendmessage,
            },
        computed: {
            ...mapState(['userProfile', 'currentUser']),

        },

        data() {
            return {
                arrayDefaultMessages:[],
                trackingNumber:'',
                shippingCarrier:'',
                shippingCarrierOptions:['FedEx', 'GSO', 'UPS', 'US Postal Service', ' DHL'],
                shippingError:false,
                itemsCost:0,
                shippingCost:0,
                deliveryCost:0,
                taxes:0,
                totalCost:0,
                
            }
        },
        methods: {
        }
        
    }
</script>

<style>
.errorclass{
        color:red;
    }
</style>